// Widget "Accesos rápidos" del Dashboard (Rediseño mayor 2026-09-01,
// destinos reales sumados en Fase 1/2 de 2026-09-02) — "Nueva consulta" y
// "Ver historia clínica" llevan al buscador de pacientes
// (PacientesPage.tsx) con el `intent` correspondiente; ahí, al elegir un
// paciente, se resuelve la acción real (mismo camino que "Iniciar nueva
// consulta" de PatientChartPage.tsx, o directo a la pestaña Historia).
// "Subir resultado" (Fase 2, 2026-09-02) también lleva al buscador de
// pacientes — con el paciente elegido y sincronizado, abre directo el
// diálogo de subida en su pestaña Documentos (`?subir=1`).
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Button } from '@/components/ui/button';

const HABILITADOS = {
  nuevaConsulta: '/pacientes?intent=consulta',
  verHistoriaClinica: '/pacientes?intent=historia',
  subirResultado: '/pacientes?intent=subir',
} as const;

export function AccesosRapidos(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="rounded-lg border border-border bg-card p-3">
      <h2 className="text-sm font-medium text-hce-ink">{t('dashboard.accesos.titulo')}</h2>
      <div className="mt-2 space-y-2">
        {(Object.entries(HABILITADOS) as [keyof typeof HABILITADOS, string][]).map(([clave, ruta]) => (
          <Button key={clave} variant="outline" size="sm" className="w-full justify-start" onClick={() => void navigate(ruta)}>
            {t(`dashboard.accesos.${clave}`)}
          </Button>
        ))}
      </div>
    </div>
  );
}
